export default __webpack_public_path__ + "static/media/mauntains_img.bf5a44a6.svg";